import { render } from "./ConnectToWifi.vue?vue&type=template&id=58e1a404"
import script from "./ConnectToWifi.vue?vue&type=script&lang=ts"
export * from "./ConnectToWifi.vue?vue&type=script&lang=ts"
script.render = render

export default script